(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_aa1d5d1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saan-signature-1972')) {
    class SaanSignature1972 extends HTMLElement {
      connectedCallback() {
        this.motionAnimations = [];
        this.motionPlayed = false;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionChange = () => {
          if (this.motionQuery.matches) this.stopMotion();
        };
        this.motionQuery.addEventListener('change', this.motionChange);
        this.motionFrame = requestAnimationFrame(() => this.observeEntrance());
      }

      observeEntrance() {
        if (!this.isConnected || this.dataset.animate !== 'true' || this.motionQuery.matches) return;
        if (!('IntersectionObserver' in window)) {
          this.playEntrance();
          return;
        }
        this.motionObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.motionObserver.disconnect();
            this.playEntrance();
          }
        }, { threshold: 0.12 });
        this.motionObserver.observe(this);
      }

      playEntrance() {
        if (this.motionPlayed || !this.isConnected || this.motionQuery.matches) return;
        this.motionPlayed = true;
        const animate = (element, frames, duration, delay = 0, easing = 'cubic-bezier(.22, 1, .36, 1)') => {
          if (!element || typeof element.animate !== 'function') return;
          this.motionAnimations.push(element.animate(frames, { duration, delay, easing, fill: 'both' }));
        };
        this.querySelectorAll('.saan-s72__digit').forEach((digit, index) => {
          animate(digit, [
            { opacity: 0, transform: 'translateY(110%)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], 1400, 100 + index * 110);
        });
        this.querySelectorAll('.saan-s72__curtain').forEach((curtain, index) => {
          animate(curtain, [
            { transform: 'scaleY(1)' },
            { transform: 'scaleY(0)' }
          ], 1550, 250 + index * 170);
        });
        animate(this.querySelector('.saan-s72__image'), [
          { transform: 'scale(1.035)' },
          { transform: 'scale(1)' }
        ], 4600, 0, 'cubic-bezier(.2, .3, .3, 1)');
        animate(this.querySelector('.saan-s72__rule'), [
          { transform: 'scaleX(0)' },
          { transform: 'scaleX(1)' }
        ], 1000, 700);
        animate(this.querySelector('.saan-s72__link'), [
          { opacity: 0, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], 1000, 1050);
        const currentAnimations = this.motionAnimations;
        Promise.allSettled(currentAnimations.map((animation) => animation.finished)).then(() => {
          currentAnimations.forEach((animation) => animation.cancel());
          if (this.motionAnimations === currentAnimations) this.motionAnimations = [];
        });
      }

      stopMotion() {
        if (this.motionObserver) this.motionObserver.disconnect();
        this.motionAnimations.forEach((animation) => animation.cancel());
        this.motionAnimations = [];
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.motionFrame);
        this.stopMotion();
        this.motionQuery.removeEventListener('change', this.motionChange);
      }
    }
    customElements.define('saan-signature-1972', SaanSignature1972);
  }
  } catch(e) { console.error(e); }
})();

})();
